/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';

import { Modal } from '../../molecules/Modal';

const StyledRow = styled(Row)`
  min-height: 100%;
  display: flex;
  flex-grow: 1;
`;

const ModalLayoutChildren = styled.div`
  box-sizing: border-box;
  min-height: 100%;

  @media (min-width: 0em) {
    padding: 8px 8px 32px 8px;
  }

  @media (min-width: 48em) {
    padding: 32px 16px;
  }
`;

const StyledModal = styled(Modal)`
  align-items: flex-start;
`;

const ModalLayout = ({ children }) => {
  const isTablet = useMediaQuery({ query: '(min-width: 48em)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 64em)' });

  const styleMap = {
    desktop: {
      minHeight: 'calc(100% - 122px)',
      margin: '60px 0'
    },
    tablet: {
      minHeight: 'calc(100% - 42px)',
      margin: '20px 0'
    },
    default: {
      minHeight: 'min-content',
      margin: '8px 0'
    }
  };

  let style = styleMap.default;

  if (isDesktop) {
    style = styleMap.desktop;
  } else if (isTablet) {
    style = styleMap.tablet;
  }

  const { minHeight, margin } = style;

  return (
    <StyledModal
      bodyStyle={{
        minHeight,
        margin
      }}
    >
      {() => (
        <StyledRow>
          <Col xs={12}>
            <ModalLayoutChildren>{children}</ModalLayoutChildren>
          </Col>
        </StyledRow>
      )}
    </StyledModal>
  );
};

ModalLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export { ModalLayout };
